
import React, { useContext, useEffect, useState } from 'react'
import Countdown from 'react-countdown';
import styled from 'styled-components'
import device from '../../theme/MediaQueries';
import { SiteContext } from '../context/SiteContext';
import ThemeDefault from '../../theme/ThemeDefault';

const CountDownDiv = styled.div`
  font-size: 2em;
  font-weight: 700;
  position: relative;
  line-height: 1;
  margin-bottom: 0.2rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 350px;
  /* grid-template-columns: repeat(4, 25%); */
  justify-content: center;

  @media ${device.MXmd} {
    font-size: 1.4em;
  }

  & span {
    position: relative;
    margin: 0 0.2rem;
    text-align: center;
    min-width: 75px;
  }

  & span:after {
    margin-left: 0.1rem;
    content: attr(data-l);
    position: relative;
    font-weight: 400;
    font-size: 0.6em;
    top: 0;
    height: 1.6rem;
    transform: translateY(-100%);
  }
`
const CountdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  
  & img {
    width: 130px;
  }
  & div,
  & spn {
    color: ${ThemeDefault.trueWhite}
  }

  & .LogoWrap {
    margin-top: 4px !important;
  }
  & .countdown-title {
    font-size: var(--text-l) !important;
  }
  

  & .countdown-text {
    margin-left: 0.8rem;
  }

  & .tag-wrap {
    position: absolute;
    top: 0;
    right: 0;
    left: 6px;
    right: 6px;
    font-size: 100%;
    width: calc(100% - 12px);
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    justify-items: flex-end;
    align-content: flex-end;
    flex-wrap: nowrap;


    & .tag {
      padding: 6px 8px 4px 8px;
      background: ${ThemeDefault.trueWhite};
      border-radius: 50px;
      margin: 6px 3px;
      color: ${ThemeDefault.primary};
      text-transform: uppercase;
      letter-spacing: 0.8px;
      font-weight: 700;
      line-height: 1; 
      font-size: var(--text-xs);
    }
  }
`

const renderer = ({ days, hours, minutes, seconds, completed, props }) => {
  if (completed) {
    // Render a completed state
    return <>
        <div className="width--full text--bold text--center countdown-title">{props.countdown.title}</div>
        <div className="countdown-text">{props.countdown.afterCountdownText}</div>
      </>;
  } else {
    // Render a countdown
    return <>
      <div className="width--full text--bold text--center countdown-title">{props.countdown.title}</div>
      { (props.countdown.tags && props.countdown.tags.length > 0) &&
        <div className="tag-wrap">
          { props.countdown.tags.map((tag)=>{
            return (<div key={props.countdown.title+tag} className="tag">{tag}</div>)
          })}
        </div>
      }

      <CountDownDiv>
        <span className="days" data-l="d">{days}</span>
        <span className="hours" data-l="h">{("0" + hours).slice(-2)}</span>
        <span className="minutes" data-l="m">{("0" + minutes).slice(-2)}</span>
        <span className="seconds" data-l="s">{("0" + seconds).slice(-2)}</span>
      </CountDownDiv>
      <div className="countdown-text text--m">{props.countdown.preCountdownText}</div>
    </>
  }
};

export default function CountdownClock({date, countdownContent}) {

  const [collectionItem, setCollectionItem] = useState(null);

  const {
    collectionsData,
  } = useContext(SiteContext)

  useEffect(() => {
    let abortController = new AbortController();
    setCollectionItem( () => {
        return (collectionsData && collectionsData.length > 0) ? collectionsData.filter((collection) => { return collection.id === countdownContent.collectionID; }).reduce(arr => arr) : null
      }
    )
    return () => abortController.abort();  
  }, [collectionsData, countdownContent])

  return (
    <CountdownWrapper className="countdown">
      {collectionItem && <div className="LogoWrap">
        <img src={collectionItem.logo} className="logo" alt={`${countdownContent.preCountdownText}`} />
      </div> }
      <Countdown renderer={renderer} date={new Date(countdownContent.countdownTo.seconds * 1000)} countdown={countdownContent} />
    </CountdownWrapper>
  )
}

